import { Button, FormControl, TextField, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import './authentication.css'
import { basicSchema } from "./validationLogin";
import { useFormik } from "formik";
import { useForgotPasswordMutation } from '../../features/authApi';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../features/slices/authSlice';
import { Store } from 'react-notifications-component';
import { useTheme } from '@emotion/react';

const ForgotPasswordForm = () => {
  const dispatch = useDispatch()

  const [forgotPassword] = useForgotPasswordMutation()

  const [loginError, setLoginError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const onSubmit = async (values, actions) => {
    
    forgotPassword({email: values.email})
    .then(res => {
      console.log("res is", res)
      if(!res.error) {
        navigate("/resetpasswordemail")
      }
      else {
        console.log("on else")
        console.log("values are", values)
        console.log("error", res)
        setErrorMessage(res.error.data.message)
        setLoginError(true)
      }
    })
    .catch((e) => {
      console.log("wrong credentials", e)
    })
  };



  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit,
  });

  console.log(errors);

  const navigate = useNavigate()

  const renderMobileForgotPassword = () => (
    <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
    <form onSubmit={handleSubmit} autoComplete="off" style={{width: '75%'}}>
      <h3 className="center">Forgot Password</h3>
      <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="email"
          type="text"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          label="email"
          margin="dense"
        />
      </FormControl>
      {errors.email && touched.email && <p className="error">{errors.email}</p>}

      {loginError && <p style={{textAlign:'center', color: 'red', fontWeight:'bold'}}>{errorMessage}</p>}

      <div className="btnContainer">
        <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
          Submit
        </Button>
      </div>
      
      <p style={{textAlign: 'center', marginBottom: '20px'}}>Don't have an account ? <Link color="secondary" sx={{width: '125px', marginTop: '10px'}} variant="contained" to="/register">Register</Link></p>
    </form>

  </div>
  )

  const renderTabletForgotPassword = () => (
    <div id="formContainer">
      <form onSubmit={handleSubmit} autoComplete="off" id="registerForm">
        <h1 className="center">Login</h1>
        <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>
        <TextField
          id="username"
          type="text"
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          label="username"
          margin="dense"
        />
        {errors.username && touched.username && <p className="error">{errors.username}</p>}

        <TextField
          id="password"
          type="password"
          margin="dense"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          label="password"
        />
        {errors.password && touched.password && (
          <p className="error">{errors.password}</p>
        )}

        {loginError && <p style={{textAlign:'center', color: 'red', fontWeight:'bold'}}>{errorMessage}</p>}

        <div className="btnContainer">
          <Button variant="contained" color="primary" id="submitBtn" type="submit">
            Submit
          </Button>
        </div>
        
        <p className="center">Don't have an account ? <Button onClick={() => navigate("/register")}>Register</Button></p>
      </form>
    </div>
  )

  const renderDesktopForgotPassword = () => (
    <div id="formContainer">
    <form onSubmit={handleSubmit} autoComplete="off">
      <h3 className="center">Forgot Password</h3>
      <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
        <TextField
          id="email"
          type="text"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          label="email"
          margin="dense"
        />
      </FormControl>
      {errors.email && touched.email && <p className="error">{errors.email}</p>}

      {loginError && <p style={{textAlign:'center', color: 'red', fontWeight:'bold'}}>{errorMessage}</p>}

      <div className="btnContainer">
        <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
          Submit
        </Button>
      </div>
      
      <p style={{textAlign: 'center', marginBottom: '20px'}}>Don't have an account ? <Link color="secondary" sx={{width: '125px', marginTop: '10px'}} variant="contained" to="/register">Register</Link></p>
    </form>

  </div>
  )
  

  return (
    <div>
        {
        (isXs) ?  renderMobileForgotPassword() : 
        (isSm) ? renderMobileForgotPassword() :
        (isMd) ? renderTabletForgotPassword() :
        renderDesktopForgotPassword()
      }
    </div>
  );
}

export default ForgotPasswordForm